module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.signals && _vm.signals.length > 0) ? _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
    }
  })])]), _vm._v("\n      Listing Signals\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "listing-signals"
  }, _vm._l((_vm.signals), function(signal, index) {
    return _c('div', {
      key: index,
      staticClass: "signal-item"
    }, [_c('div', {
      staticClass: "signal-icon"
    }, [_vm._v(_vm._s(signal.icon))]), _vm._v(" "), _c('div', {
      staticClass: "signal-body"
    }, [_c('div', {
      staticClass: "signal-name"
    }, [_vm._v(_vm._s(signal.name))]), _vm._v(" "), _c('div', {
      staticClass: "signal-status",
      class: signal.active ? 'active' : 'inactive'
    }, [_c('span', {
      staticClass: "signal-dot"
    }), _vm._v(_vm._s(signal.active ? 'Active' : 'Not active') + "\n        ")])])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04b013fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/ListingSignals.vue
// module id = 716
// module chunks = 2